import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { expiry } from 'utils/DateHelper';

const CreditLinesPreviewRecord = Record({
  amount: 0,
  balance: 0,
  endDate: new Date(0),
});

export default class CreditLinesPreview extends CreditLinesPreviewRecord {
  static deserialize(jsonObject) {
    if (
      typeof jsonObject === 'undefined' ||
      jsonObject === null ||
      (typeof jsonObject === 'object' && !Object.keys(jsonObject).length)
    ) {
      return undefined;
    }

    const mapProperties = {
      endDate: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CreditLinesPreview(hydrated);
  }

  get repaid() {
    return this.amount - Math.abs(this.balance);
  }

  get percentRepaid() {
    return Math.min(Math.floor((this.repaid / this.amount) * 100), 100);
  }

  get isSuccessful() {
    return this.percentRepaid > 80;
  }

  get expiry() {
    return expiry(this.endDate);
  }
}
